// extracted by mini-css-extract-plugin
export default {"cls1":"ErrorMessage_cls1__RqN2J","cls2":"ErrorMessage_cls2__Y380H ErrorMessage_cls1__RqN2J"};